var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedinreact = function SvgLinkedinreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-linkedin",
    d: "M22.286 0H1.709A1.722 1.722 0 0 0 0 1.73v20.54A1.722 1.722 0 0 0 1.709 24h20.577A1.726 1.726 0 0 0 24 22.27V1.73A1.726 1.726 0 0 0 22.286 0ZM7.254 20.571H3.7V9.118h3.559v11.453ZM5.475 7.55a2.063 2.063 0 1 1 2.062-2.059A2.063 2.063 0 0 1 5.475 7.55Zm15.112 13.021H17.03V15c0-1.329-.027-3.037-1.848-3.037-1.854 0-2.137 1.446-2.137 2.941v5.668H9.487V9.118H12.9v1.564h.048a3.747 3.747 0 0 1 3.37-1.848c3.6 0 4.27 2.373 4.27 5.459Z"
  })));
};

export default SvgLinkedinreact;